/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { IFancyFirebaseStateCatalogGetter } from './interfaces/IFancyFirebaseStateCatalogGetter';
import { fancyFirebaseReferencer } from './services/FancyFirebaseReferencer';
import { IFancyConfig, fancyConfig } from './FancyConfig';
import { FancyDatabase, IRefLike } from '@touchplan/common';

/**
 * Initializes fancy firebase. Calling this will enable the use of fancyFirebaseReferencer.
 * @param firebaseState Catalog getter
 * @param databaseCb Getter for database. Should return either firebase.database.Database or admin.database.Database
 * @param config Fancy configuration
 */
export function initFancyFirebase<DbRef extends IRefLike>(
	firebaseState: IFancyFirebaseStateCatalogGetter,
	firebaseDatabase: FancyDatabase<DbRef>,
	config: IFancyConfig
): void {
	// BEGIN PLACEHOLDER REPLACE AS PART OF TP-6697
	// no real way to make a useful generic singleton, soooo... half ass it until we eliminate the ref
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	fancyFirebaseReferencer.init(firebaseState, firebaseDatabase as any);
	// END PLACEHOLDER REPLACE AS PART OF TP-6697
	fancyConfig.init(config);
}
